module.exports = __webpack_public_path__ + "static/img/fin-lit-course-video.f67006ee.png";